import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a83cc93c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    class: "form-select form-select-sm chart-type-select",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
  }, [
    _createElementVNode("option", {
      value: _ctx.ReportChartType.Bar
    }, "Bar", 8, _hoisted_1),
    _createElementVNode("option", {
      value: _ctx.ReportChartType.Line
    }, "Line", 8, _hoisted_2),
    _createElementVNode("option", {
      value: _ctx.ReportChartType.Pie
    }, "Pie", 8, _hoisted_3)
  ], 544)), [
    [_vModelSelect, _ctx.selected]
  ])
}